import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const InquiryModal = ({ isOpen, toggle, onSubmit, propertyName }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [noOfPeople, setNoOfPeople] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [errors, setErrors] = useState({});

  const customerTypeOptions = [
    { value: "bachelors", label: "Bachelors (boys group)" },
    { value: "girlsGroup", label: "Girls group" },
    { value: "couples", label: "Couples" },
    { value: "corporate", label: "Corporate" },
    { value: "family", label: "Family" }
  ];

  const getTodayKey = () => {
    return new Date().toISOString().split("T")[0];
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    if (userData) {
      setName(userData.name || "");
      setEmail(userData.email || "");
      setContact(userData.contact || "");
    }
  }, [isOpen]);

  const getMidnightTimestamp = () => {
    const now = new Date();
    now.setHours(23, 59, 59, 999);
    return now.getTime();
  };

  const validate = () => {
    const newErrors = {};
    if (!name) newErrors.name = true;
    if (!email) newErrors.email = true;
    if (!contact) newErrors.contact = true;
    if (!noOfPeople) newErrors.noOfPeople = true;
    if (!customerType) newErrors.customerType = true;
    if (!startDate) newErrors.startDate = true;
    if (!endDate) newErrors.endDate = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    const payload = {
      name,
      email,
      contact,
      noOfPeople,
      customerType,
      startDate,
      endDate
    };

    localStorage.setItem(
      "commonEnquiryData",
      JSON.stringify({
        data: payload,
        expiresAt: getMidnightTimestamp()
      })
    );

    onSubmit(payload);
    toggle();
  };

  const getInputClass = (field) =>
    errors[field] ? "custom-input error" : "custom-input";

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg" className="custom-modal">
      <div className="modal-container">

        {/* LEFT IMAGE SECTION */}
        <div className="modal-left">
          <div className="overlay-content">
            <h2>Book Your Stay</h2>
            <p>Luxury. Comfort. Privacy.</p>
          </div>
        </div>

        {/* RIGHT FORM SECTION */}
        <div className="modal-right">

          <div className="modal-header-custom">
            <h4>Inquiry for {propertyName || "Property"}</h4>
   <span
  className="close-btn"
  onClick={() => {
    toggle();
    window.history.back(); // 👈 ADD THIS
  }}
>
  ×
</span>
          </div>

          <div className="form-container">

            <input
              type="text"
              className={getInputClass("name")}
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Full Name"
            />
            {errors.name && <p className="error-text">Name is required</p>}

            <input
              type="email"
              className={getInputClass("email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email Address"
            />
            {errors.email && <p className="error-text">Email is required</p>}

            <input
              type="text"
              className={getInputClass("contact")}
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              placeholder="Contact Number"
            />
            {errors.contact && <p className="error-text">Contact number required</p>}

            <input
              type="number"
              min="1"
              className={getInputClass("noOfPeople")}
              value={noOfPeople}
              onChange={(e) => setNoOfPeople(e.target.value)}
              placeholder="Number of Guests"
            />
            {errors.noOfPeople && <p className="error-text">Enter restrictions count</p>}

            <select
              className={getInputClass("customerType")}
              value={customerType}
              onChange={(e) => setCustomerType(e.target.value)}
            >
              <option value="">Select Customer Type</option>
              {customerTypeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.customerType && <p className="error-text">Select customer type</p>}

            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              minDate={new Date()}
              placeholderText="Check-in Date"
              className={getInputClass("startDate")}
            />
            {errors.startDate && <p className="error-text">Select check-in</p>}

            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              minDate={startDate}
              placeholderText="Check-out Date"
              className={getInputClass("endDate")}
            />
            {errors.endDate && <p className="error-text">Select check-out</p>}

            <button className="submit-btn" onClick={handleSubmit}>
              Submit Inquiry
            </button>

          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InquiryModal;